import { useState } from 'react';
import {
  getCurrencySetup,
  getMeasurementSetup,
  updateCurrencySetup,
  updateMeasurementSetup,
} from 'requests/settings';
import { useDictionary } from 'models/dictionaryContext';
import { EDictionaryTypes } from 'models/dictionary';
import { IUnitsCurrencyFormValues } from '.';

export const useUnitsCurrencySetup = () => {
  const [currencyValue, setCurrencyValue] = useState<string | undefined>();
  const [measurementValue, setMeasurementValue] = useState<string | undefined>();
  const { getCurrency, currency, getMeasurement, measurement } = useDictionary();

  const loadInitData = () => {
    getCurrencySetup().then((result) => setCurrencyValue(result?.value));
    getMeasurementSetup().then((result) => setMeasurementValue(result?.value));
  };

  const updateUnitsCurrencyData = async (data: IUnitsCurrencyFormValues) => {
    if (data.currency !== null && data.measurement !== null) {
      await updateCurrencySetup(data.currency);
      await updateMeasurementSetup(data.measurement);
    }
  };

  const loadDictionaries = async (types: EDictionaryTypes[]) => {
    if (types.includes(EDictionaryTypes.currency)) {
      getCurrency();
    }
    if (types.includes(EDictionaryTypes.measurementUnit)) {
      getMeasurement();
    }
  };

  return {
    currencyValue,
    measurementValue,
    loadInitData,
    updateUnitsCurrencyData,
    loadDictionaries,
    currency,
    measurement,
  };
};
